module.exports = __webpack_public_path__ + "38802b0b162bfefcc60ebf01d0a20b32.pdf";